import React, { useEffect, useState } from 'react';
import { Horse } from '../../contexts/HorseContext';
import { XIcon, CheckIcon, RefreshCwIcon } from 'lucide-react';
interface CountdownModalProps {
  isOpen: boolean;
  onComplete: (detectedWeight?: number) => void;
  horse: Horse;
}
export const CountdownModal: React.FC<CountdownModalProps> = ({
  isOpen,
  onComplete,
  horse
}) => {
  const [detectedWeight, setDetectedWeight] = useState<number | null>(null);
  const [isWeighing, setIsWeighing] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(5);
  useEffect(() => {
    if (!isOpen) {
      // Reset state when modal closes
      setDetectedWeight(null);
      setIsWeighing(true);
      setTimeRemaining(5);
      return;
    }
    // Start the weighing process immediately
    if (isWeighing) {
      const timer = setTimeout(() => {
        // Generate a random weight based on previous weights or a default range
        let baseWeight = 450; // default
        if (horse.weights.length > 0) {
          const lastWeight = [...horse.weights].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0].weight;
          baseWeight = lastWeight;
        }
        // Random weight within +/- 5% of last weight
        const randomWeight = Math.round(baseWeight * (0.95 + Math.random() * 0.1));
        setDetectedWeight(randomWeight);
        setIsWeighing(false);
      }, 5000); // 5 seconds for weighing process
      // Update the time remaining every second
      const countdownInterval = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
  }, [isOpen, isWeighing, horse.weights]);
  const handleWeighAgain = () => {
    setIsWeighing(true);
    setTimeRemaining(5);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-235">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md text-center p-6" data-id="element-236">
        <button onClick={() => onComplete()} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-237">
          <XIcon size={20} data-id="element-238" />
        </button>
        {isWeighing ? <>
            <h2 className="text-xl font-semibold mb-4" data-id="element-239">Pferd wird verwogen</h2>
            <div className="my-8 flex justify-center" data-id="element-240">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8peiRiYy35uPaqpzRcR9T9/horse.gif" alt="Pferd wird verwogen" className="w-64 h-64 object-cover rounded-md" data-id="element-241" />
            </div>
            <p className="text-gray-600" data-id="element-242">
              Bitte warten Sie, während die Messung durchgeführt wird... (
              {timeRemaining}s)
            </p>
          </> : <>
            <h2 className="text-xl font-semibold mb-4" data-id="element-243">
              Verwiegung abgeschlossen
            </h2>
            <div className="text-4xl font-bold text-[#284755] my-6" data-id="element-244">
              {detectedWeight} kg
            </div>
            <div className="flex justify-center gap-4 mt-6" data-id="element-245">
              <button onClick={handleWeighAgain} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center hover:bg-[#96c11f] hover:text-white hover:border-[#96c11f]" data-id="element-246">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-247" />
                Erneut verwiegen
              </button>
              <button onClick={() => onComplete(detectedWeight || undefined)} className="px-4 py-2 bg-[#284755] text-white rounded-md flex items-center hover:bg-[#96c11f]" data-id="element-248">
                <CheckIcon size={18} className="mr-2" data-id="element-249" />
                Übernehmen
              </button>
            </div>
          </>}
      </div>
    </div>;
};